import { useEffect, useState } from 'react';
import { EntityPageState, EntityPageStateParams } from '../state';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { FieldValues } from 'react-hook-form';

export interface UseEntityPageParams<T, V extends FieldValues = FieldValues>
  extends Pick<
    EntityPageStateParams<T, V>,
    'fetch' | 'onSave' | 'saveErrorToast' | 'form' | 'parentPageId'
  > {}

export function useEntityPage<T, V extends FieldValues = FieldValues>(
  props: UseEntityPageParams<T, V>,
): EntityPageState<T, V> {
  const container = useWixPatternsContainer();
  const [state] = useState(() => new EntityPageState({ container, ...props }));

  const {
    formState: { isSubmitSuccessful, isDirty },
  } = props.form;

  /* formState is wrapped with a Proxy to improve render performance and skip extra logic if specific state is not subscribed to.
  Therefore, make sure you invoke or read it before a render in order to enable the state update. */
  useEffect(() => {
    state.isSubmitSuccessful = isSubmitSuccessful;
    state.isFormDirty = isDirty;
  }, [isSubmitSuccessful, isDirty]);

  return state;
}
